export default __webpack_public_path__ + "static/media/c1596b2f9f75a3d68235778af87e4b651576781547759.be28fc60.webp";